export default {
    data: () => ({
        order: []
    }),
    computed: {
        locale() {
            const { locale } = this.$i18n;
            return locale === "ko" ? "ko" : "en";
        }
    },
    watch: {
        locale: {
            immediate: true,
            async handler(locale) {
                const { default: order } = await import(
                    `@/data/guides/${locale}/order.json`
                );
                this.order = order;
            }
        }
    }
};
